module.exports = __webpack_public_path__ + "img/1F513.e4c23945.svg";